export class TooManyLoginAttemptsError extends Error {
  constructor() {
    super('Too many failed login attempts');

    // Changing prototype for extending default class is recommended by TS
    // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, TooManyLoginAttemptsError.prototype);

    this.name = 'TooManyLoginAttemptsError';
  }
}
